// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SharedUpsearchModelEnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel {
    static getAttributeTypeMap() {
        return SharedUpsearchModelEnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel.attributeTypeMap;
    }
}
SharedUpsearchModelEnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel.discriminator = undefined;
SharedUpsearchModelEnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel.additionalProperties = false;
SharedUpsearchModelEnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel.attributeTypeMap = [
    {
        "name": "canUpdate",
        "baseName": "canUpdate",
        "type": "boolean"
    },
    {
        "name": "canInsert",
        "baseName": "canInsert",
        "type": "boolean"
    },
    {
        "name": "skipSearch",
        "baseName": "skipSearch",
        "type": "boolean"
    },
    {
        "name": "model",
        "baseName": "model",
        "type": "EnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel"
    },
];
//# sourceMappingURL=sharedUpsearchModelEnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel.js.map